import React, { PropsWithChildren } from 'react';
import { NativeProps } from '@/src/components/interfaces';
import classNames from 'classnames';

export enum CListItemSpacing {
  Adjusted = 'adjusted',
  Xxlg = 'xxlg',
  Xlg = 'xlg',
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xs = 'xs',
  Xxs = 'xxs',
  None = 'none',
}

export interface CListItemProps extends NativeProps {
  spacing?: CListItemSpacing;
}

export function CListItem({
  children,
  spacing = CListItemSpacing.Adjusted,
  class: className,
  onClick,
  testSelector,
  id,
}: PropsWithChildren<CListItemProps>): React.JSX.Element {
  return (
    <li id={id} data-test-selector={testSelector} onClick={onClick} className={classNames('c-list-item', `c-list-item--spacing-${spacing}`, className)}>
      {children}
    </li>
  );
}